import { CommonOperationTaxes } from '../operation-taxes'

export const CanadaOperationTaxes = {
  ...CommonOperationTaxes,
} as const
